import { ErrorHandlerService } from '@loavies/utils'
import { mapRelations } from '../response-mappers/relations-mapper'

export class MarketplaceImageService {
  constructor(marketplaceService) {
    this.marketplace = marketplaceService.instance
    this.errorHandlerService = new ErrorHandlerService()
  }

  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#upload-image
   * @param {File|Blob} file
   * @return {Promise<string>} created image id
   */
  uploadImage(file) {
    return this.marketplace.images
      .upload({ image: file })
      .then(response => mapRelations(response.data))
      .then(response => response.data.id.uuid)
      .catch(response => Promise.reject(this.errorHandlerService.mapMarketplaceErrors(response.data.errors)))
  }
}
